import React from 'react';
import { SimpleSelectionDto } from '../product-details/types';
import classnames from 'classnames';

interface ProductAttributeListprops {
	selections?: SimpleSelectionDto[];
	classNamePrefix?: string;
}

export default function ProductSelectionsList(props: ProductAttributeListprops) {
	const { selections, classNamePrefix = '' } = props;

	const parentClass = 'roc-bare-table';
	const parentPrefixClass = classNamePrefix + '-' + parentClass;

	const itemClass = parentClass + '__item';
	const itemPrefixClass = classNamePrefix + '-' + itemClass;

	const labelClass = parentClass + '__label';
	const labelPrefixClass = classNamePrefix + '-' + labelClass;

	const valueClass = parentClass + '__value';
	const valuePrefixClass = classNamePrefix + '-' + valueClass;

	return (
		<ul className={classnames(parentClass, { [`${parentPrefixClass}`]: classNamePrefix })}>
			{selections !== undefined &&
				Array.isArray(selections) &&
				selections.length > 0 &&
				//#region Tapecase customization
				selections
					.filter((sel) => sel.name.toUpperCase() != 'SKU')
					.map((selection, i) => (
						//#end region
						<li className={classnames(itemClass, { [`${itemPrefixClass}`]: classNamePrefix })} key={i}>
							<span className={classnames(labelClass, { [`${labelPrefixClass}`]: classNamePrefix })}>
								{selection.name}:
							</span>
							<span className={classnames(valueClass, { [`${valuePrefixClass}`]: classNamePrefix })}>
								{selection.label}
							</span>
						</li>
					))}
		</ul>
	);
}
